import { FC } from 'react';
import InputWithSuffix from '../InputWithSuffix';
import { Image, InputProps } from '@qga/roo-ui/components';
import { qantasQff } from '@qga/roo-ui/logos';

type Props = InputProps;

const QffInput: FC<Props> = (props) => (
  <InputWithSuffix {...props}>
    <Image src={qantasQff} alt="Qantas Frequent Flyer Logo" />
  </InputWithSuffix>
);

export default QffInput;
